import { decodeHtmlEntities } from 'shared/utils/textFormatters/textFormatters';

import type {
    CatalogItem,
    DisplayItem,
    GlobalCatalogItem,
} from 'entities/CatalogItem/model/types/CatalogItemSchema';

const globalCategoryLabel = (item: GlobalCatalogItem): string => {
    if (!item.category) {
        return '';
    }
    if (item.category.parentCategory?.catName) {
        return `${item.category.parentCategory.catName} / ${item.category.catName}`;
    }
    return item.category.catName ?? '';
};

export const mapGlobalCatalogItemToDisplayItem = (
    item: GlobalCatalogItem,
): DisplayItem => ({
    name: decodeHtmlEntities(item.name),
    category: globalCategoryLabel(item),
    sku: item.sku,
    uom: item.uom,
    qtyPerUom: item.qtyPerUom,
    uomPrice: item.uomPrice,
    imageUrl: item.imageUrl,
    thumbnailUrl: item.thumbnailUrl,
    manufacturerId: item.manufacturerId,
    mpn: item.mpn,
    upc: item.upc,
    brand: decodeHtmlEntities(item.brand ?? ''),
    msrp: item.msrp,
    unspsc: item.unspsc,
    description: item.description,
    descriptionFormat: item.descriptionFormat,
    prop65Warning: item.prop65Warning,
    specifications: item.specifications,
    additionalImages: item.additionalImages,
    proposals: item.proposals ?? [],
    isAddedToCatalog: item.isAddedToCatalog,
});

export const mapCatalogItemToDisplayItem = (item: CatalogItem): DisplayItem => {
    const maybeGlobalCategory = (
        item as CatalogItem & { category?: GlobalCatalogItem['category'] }
    ).category;
    let category = '';

    if (maybeGlobalCategory && typeof maybeGlobalCategory === 'object') {
        const parent = maybeGlobalCategory.parentCategory;
        if (parent?.catName) {
            category = `${parent.catName} / ${maybeGlobalCategory.catName}`;
        } else if (maybeGlobalCategory.catName) {
            category = maybeGlobalCategory.catName;
        }
    }

    return {
        name: decodeHtmlEntities(item.title),
        category,
        sku: item.sku,
        uom: item.uom,
        qtyPerUom: item.qtyPerUom,
        uomPrice: item.uomPrice,
        imageUrl: item.imageUrl,
        thumbnailUrl: item.thumbnailUrl,
        manufacturerId: item.manufacturerId,
        mpn: item.mpn,
        upc: item.upc,
        brand: decodeHtmlEntities(item.brand ?? ''),
        msrp: item.msrp,
        unspsc: item.unspsc,
        description: item.description,
        descriptionFormat: item.descriptionFormat,
        prop65Warning: item.prop65Warning,
        specifications: item.specifications,
        additionalImages: item.additionalImages,
        proposals: item.proposals,
        glCode: item.glCode,
    };
};
